import { disconnectSocket } from '../socket2/ZionSocketClient.ts'
import { lockSession } from '../identity/ZionIdentityManager.ts'
import { getRequireUnlockOnOpen, getWipeOnExit } from '../storage/privacySettingsStore.ts'
import { wipeVolatileOnExit } from './factoryReset.ts'
import { navigate } from '../ui/router.ts'

/** Exit: disconnette, wipe opzionale, torna al blocco se richiesto. */
export async function exitApp(): Promise<void> {
  disconnectSocket()
  if (getWipeOnExit()) {
    await wipeVolatileOnExit()
  }
  if (getRequireUnlockOnOpen()) {
    lockSession()
    navigate('auth')
    return
  }
  try {
    window.close()
  } catch {
    /* PWA spesso blocca close */
  }
  navigate('home')
}
